<div class="dialog-header d-flex align-items-center justify-content-between p-3 border-bottom">
  <div class="d-flex align-items-center gap-3">
    <div class="dialog-header-icon" [ngClass]="fileExt">
      <mat-icon>{{ getDocTypeIcon() }}</mat-icon>
    </div>
    <div>
      <h3 class="dialog-title mb-0 fw-bold text-truncate" style="max-width: 500px;">
        {{ data.title || data.filename || 'Document Preview' }}
      </h3>
      <div class="d-flex align-items-center gap-2 mt-1">
        <span class="doc-badge" [ngClass]="fileExt">{{ getDocTypeLabel() }}</span>
        <span class="dialog-subtitle mb-0" *ngIf="data.filename">{{ data.filename }}</span>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-center gap-2">
    <a [href]="data.url" target="_blank" class="btn btn-sm btn-outline-secondary d-none d-sm-inline-flex align-items-center gap-1" matTooltip="Open original file in new tab">
      <mat-icon class="fs-6">open_in_new</mat-icon>
      <span>Open</span>
    </a>
    <button type="button" class="btn btn-sm btn-primary d-none d-sm-inline-flex align-items-center gap-1" (click)="download()" matTooltip="Download file">
      <mat-icon class="fs-6">download</mat-icon>
      <span>Download</span>
    </button>
    <button type="button" mat-icon-button class="dialog-close-btn flex-shrink-0" mat-dialog-close aria-label="Close" matTooltip="Close preview">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="dialog-content">
  <!-- Document Mode Switcher Toolbar (for Non-Images) -->
  <div class="doc-mode-toolbar d-flex flex-wrap align-items-center justify-content-between p-2 px-3 border-bottom bg-light" *ngIf="!isImage()">
    <div class="d-flex align-items-center gap-2">
      <!-- Excel Mode Buttons -->
      <div class="btn-group btn-group-sm" *ngIf="isExcel()">
        <button type="button" class="btn" [class.btn-primary]="viewerMode === 'native'" [class.btn-outline-secondary]="viewerMode !== 'native'" (click)="viewerMode = 'native'">
          <mat-icon class="btn-mini-icon">grid_on</mat-icon> Sheet Table
        </button>
        <button type="button" class="btn" [class.btn-primary]="viewerMode === 'office'" [class.btn-outline-secondary]="viewerMode !== 'office'" (click)="viewerMode = 'office'">
          Office Viewer
        </button>
        <button type="button" class="btn" [class.btn-primary]="viewerMode === 'google'" [class.btn-outline-secondary]="viewerMode !== 'google'" (click)="viewerMode = 'google'">
          Google Docs
        </button>
      </div>

      <!-- Word Mode Buttons -->
      <div class="btn-group btn-group-sm" *ngIf="isWord()">
        <button type="button" class="btn" [class.btn-primary]="viewerMode === 'office'" [class.btn-outline-secondary]="viewerMode !== 'office'" (click)="viewerMode = 'office'">
          Office Viewer
        </button>
        <button type="button" class="btn" [class.btn-primary]="viewerMode === 'google'" [class.btn-outline-secondary]="viewerMode !== 'google'" (click)="viewerMode = 'google'">
          Google Docs
        </button>
      </div>

      <!-- PDF Mode Buttons -->
      <div class="btn-group btn-group-sm" *ngIf="isPdf()">
        <button type="button" class="btn" [class.btn-primary]="viewerMode === 'direct'" [class.btn-outline-secondary]="viewerMode !== 'direct'" (click)="viewerMode = 'direct'">
          PDF Viewer
        </button>
        <button type="button" class="btn" [class.btn-primary]="viewerMode === 'google'" [class.btn-outline-secondary]="viewerMode !== 'google'" (click)="viewerMode = 'google'">
          Google Docs
        </button>
      </div>
    </div>

    <div class="d-flex align-items-center gap-2">
      <button mat-icon-button (click)="toggleFullscreen()" [matTooltip]="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'">
        <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
      </button>
    </div>
  </div>

  <!-- IMAGE VIEWPORT -->
  <ng-container *ngIf="isImage()">
    <div class="preview-viewport">
      <div class="image-container" (mousedown)="handleMouseDown($event)" (mousemove)="handleMouseMove($event)"
        (mouseup)="handleMouseUp()" (mouseleave)="handleMouseUp()"
        [style.cursor]="zoomLevel > 100 ? (isDragging ? 'grabbing' : 'grab') : 'default'">
        <img #imageRef [src]="data.url" alt="Preview" class="preview-image"
          [style.transform]="'scale(' + (zoomLevel / 100) + ') rotate(' + rotation + 'deg) translate(' + position.x + 'px, ' + position.y + 'px)'"
          [style.transform-origin]="'center center'" draggable="false" />
      </div>

      <!-- Navigation Buttons for Multiple Attachments -->
      <button class="nav-btn prev-btn" *ngIf="hasMultipleAttachments() && data.currentIndex !== undefined && data.currentIndex > 0" (click)="prevAttachment()" matTooltip="Previous Document">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button class="nav-btn next-btn" *ngIf="hasMultipleAttachments() && data.currentIndex !== undefined && data.attachments && data.currentIndex < data.attachments.length - 1" (click)="nextAttachment()" matTooltip="Next Document">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </ng-container>

  <!-- NON-IMAGE VIEWPORTS (PDF, Word, Excel, HTML) -->
  <ng-container *ngIf="!isImage()">
    <div class="preview-viewport">
      <!-- Excel Native SheetJS Grid -->
      <div class="excel-viewer-container" *ngIf="isExcel() && viewerMode === 'native'">
        <div class="excel-loading text-center p-4" *ngIf="loadingDoc">
          <mat-spinner diameter="36" class="mx-auto mb-2"></mat-spinner>
          <span class="text-muted">Loading spreadsheet data...</span>
        </div>

        <!-- Sheet selection tabs -->
        <div class="sheet-tabs-bar" *ngIf="!loadingDoc && excelSheets.length > 1">
          <button *ngFor="let sheet of excelSheets; let sIdx = index"
                  type="button"
                  class="sheet-tab-btn"
                  [class.active]="selectedSheetIndex === sIdx"
                  (click)="selectedSheetIndex = sIdx">
            <mat-icon class="sheet-icon">grid_on</mat-icon>
            {{ sheet.name }}
          </button>
        </div>

        <!-- Excel Table Grid -->
        <div class="excel-table-scroll" *ngIf="!loadingDoc && excelSheets.length > 0 && excelSheets[selectedSheetIndex]">
          <table class="excel-table">
            <tbody>
              <tr *ngFor="let row of excelSheets[selectedSheetIndex].data; let rIdx = index" [class.header-row]="rIdx === 0">
                <td class="row-num-cell">{{ rIdx + 1 }}</td>
                <td *ngFor="let cell of row" [title]="cell">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="excel-empty p-4 text-center text-muted" *ngIf="!loadingDoc && excelSheets.length === 0">
          <mat-icon class="fs-2 text-secondary mb-2">table_view</mat-icon>
          <p class="mb-2">Unable to display sheet preview directly.</p>
          <button type="button" class="btn btn-sm btn-primary" (click)="viewerMode = 'office'">Switch to Office Viewer</button>
        </div>
      </div>

      <!-- Office Online Iframe Viewer (Word & Excel) -->
      <div class="html-preview-container" *ngIf="viewerMode === 'office'">
        <iframe [src]="safeOfficeUrl" frameborder="0" class="html-iframe" allowfullscreen="true"></iframe>
      </div>

      <!-- Google Docs Iframe Viewer (Word, Excel, PDF) -->
      <div class="html-preview-container" *ngIf="viewerMode === 'google'">
        <iframe [src]="safeGoogleUrl" frameborder="0" class="html-iframe" allowfullscreen="true"></iframe>
      </div>

      <!-- Direct Iframe Viewer (PDF / HTML / Text) -->
      <div class="html-preview-container" *ngIf="viewerMode === 'direct'">
        <iframe [src]="safeImageUrl" frameborder="0" class="html-iframe" allowfullscreen="true"></iframe>
      </div>

      <!-- Navigation Buttons for Multiple Attachments -->
      <button class="nav-btn prev-btn" *ngIf="hasMultipleAttachments() && data.currentIndex !== undefined && data.currentIndex > 0" (click)="prevAttachment()" matTooltip="Previous Document">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button class="nav-btn next-btn" *ngIf="hasMultipleAttachments() && data.currentIndex !== undefined && data.attachments && data.currentIndex < data.attachments.length - 1" (click)="nextAttachment()" matTooltip="Next Document">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </ng-container>

  <!-- Thumbnails navigation at bottom for multiple files -->
  <div class="thumbnails-container" *ngIf="hasMultipleAttachments()">
    <div *ngFor="let file of data.attachments; let idx = index" 
         class="thumbnail-item" 
         [class.active]="idx === data.currentIndex"
         [matTooltip]="getFileName(file)"
         (click)="showAttachmentAtIndex(idx)">
      <ng-container [ngSwitch]="getFileType(file)">
        <img *ngSwitchCase="'image'" [src]="getAttachmentFullUrl(file)" class="thumbnail-img" />
        <div *ngCase="'pdf'" class="thumbnail-fallback pdf-fallback">
          <mat-icon>picture_as_pdf</mat-icon>
          <span class="thumb-lbl">PDF</span>
        </div>
        <div *ngCase="'doc'" class="thumbnail-fallback word-fallback">
          <mat-icon>description</mat-icon>
          <span class="thumb-lbl">DOC</span>
        </div>
        <div *ngCase="'xls'" class="thumbnail-fallback excel-fallback">
          <mat-icon>table_view</mat-icon>
          <span class="thumb-lbl">XLS</span>
        </div>
        <div *ngSwitchDefault class="thumbnail-fallback generic-fallback">
          <mat-icon>insert_drive_file</mat-icon>
          <span class="thumb-lbl">FILE</span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Bottom Controls for Image Zoom & Navigation -->
  <div class="controls-container" *ngIf="isImage()">
    <div class="all-controls-row">
      <div class="zoom-controls-group">
        <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= 25" matTooltip="Zoom Out">
          <mat-icon>zoom_out</mat-icon>
        </button>

        <div class="zoom-slider-group">
          <input type="range" [value]="zoomLevel" (input)="handleZoomChange($any($event.target).valueAsNumber)"
            min="25" max="500" step="25" class="zoom-slider-input" />
          <span class="zoom-percentage">{{ zoomLevel }}%</span>
        </div>

        <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= 500" matTooltip="Zoom In">
          <mat-icon>zoom_in</mat-icon>
        </button>
      </div>

      <div class="action-buttons-group">
        <button mat-icon-button (click)="rotate()" matTooltip="Rotate 90°">
          <mat-icon>refresh</mat-icon>
        </button>

        <button mat-button (click)="reset()" matTooltip="Reset Zoom & Rotation">
          Reset
        </button>

        <button mat-icon-button (click)="toggleFullscreen()" [matTooltip]="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'">
          <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        </button>

        <button mat-flat-button color="primary" (click)="download()" *ngIf="data.url">
          Download
        </button>
        <button mat-button mat-dialog-close>
          Close
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
